var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDnd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.19658 3.5C2.85743 3.5 3.39316 3.05228 3.39316 2.5C3.39316 1.94772 2.85743 1.5 2.19658 1.5C1.53573 1.5 1 1.94772 1 2.5C1 3.05228 1.53573 3.5 2.19658 3.5Z",
    stroke: "#878F9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7688 3.5C12.4297 3.5 12.9654 3.05228 12.9654 2.5C12.9654 1.94772 12.4297 1.5 11.7688 1.5C11.108 1.5 10.5723 1.94772 10.5723 2.5C10.5723 3.05228 11.108 3.5 11.7688 3.5Z",
    stroke: "#878F9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19658 11.5C2.85743 11.5 3.39316 11.0523 3.39316 10.5C3.39316 9.94772 2.85743 9.5 2.19658 9.5C1.53573 9.5 1 9.94772 1 10.5C1 11.0523 1.53573 11.5 2.19658 11.5Z",
    stroke: "#878F9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7688 11.5C12.4297 11.5 12.9654 11.0523 12.9654 10.5C12.9654 9.94772 12.4297 9.5 11.7688 9.5C11.108 9.5 10.5723 9.94772 10.5723 10.5C10.5723 11.0523 11.108 11.5 11.7688 11.5Z",
    stroke: "#878F9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19658 19.5C2.85743 19.5 3.39316 19.0523 3.39316 18.5C3.39316 17.9477 2.85743 17.5 2.19658 17.5C1.53573 17.5 1 17.9477 1 18.5C1 19.0523 1.53573 19.5 2.19658 19.5Z",
    stroke: "#878F9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7688 19.5C12.4297 19.5 12.9654 19.0523 12.9654 18.5C12.9654 17.9477 12.4297 17.5 11.7688 17.5C11.108 17.5 10.5723 17.9477 10.5723 18.5C10.5723 19.0523 11.108 19.5 11.7688 19.5Z",
    stroke: "#878F9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnd);
export default __webpack_public_path__ + "static/media/dnd.fcfa547acce89cf98960306c7c16fb85.svg";
export { ForwardRef as ReactComponent };